export default __webpack_public_path__ + "static/media/nav-icon.4ecb121b.png";